import { map } from 'rxjs/operators';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { Command } from '../../../core/model/command';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { companyCommand } from '../../command/company.command';
import { Company } from '../../model/company';
import { CompanyVismaConfigComponent } from '../../component/company-visma-config/company-visma-config.component';

@Injectable()
export class CompanyVismaConfigCommandHandler implements ICommandHandler {
  constructor(
    private _actionService: ActionWindowService,
    private _injector: Injector
  ) {}

  canExecute(command: Command): boolean {
    return command.id === companyCommand.vismaConfig;
  }

  execute(command: Command): Observable<boolean> {
    return this._actionService.open(CompanyVismaConfigComponent, this._injector, null, command.context).pipe(
      map(result => {
        return true;
      })
    );
  }
}
